module.exports = __webpack_public_path__ + "img/avanza-pais---partido-de-integracion-social.195fd810.png";